import { RequestStatus } from "../enums/requestStatus";
import {notifySuccess,notifyError}  from "../components/Toast";

const simulateApiPost = (data) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ status: 200, message: "Success", data, ok: true });
      //reject({ status: 500, statusText: "Internal Server Error", ok:false });
    }, 2000);
  });
};

export const getFileRequest = (fileName, user) => async (dispatch) => {
  try {
    dispatch({ type: 'GET_FILE_REQUEST' });

    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/respuestas/Solicitudes-Contenidos-${fileName.substring(0, 4)}/getFile/${fileName}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + user.token
      },
    });
    

    if (response.ok) {
      const blob = await response.blob();
      dispatch({ type: 'GET_FILE_REQUEST_SUCCESS' });
       
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(downloadUrl);
    } else {
      const errorData = await response.statusText;
      dispatch({ type: 'GET_FILE_REQUEST_FAIL', payload: errorData });
    }

  }
  catch (error){
    dispatch({ type: 'GET_FILE_REQUEST_ERROR', payload: error.message });
  }
};

export const getCVRequest = (requestId, user) => async (dispatch) => {
  try {
    dispatch({ type: 'GET_CV_REQUEST' });

    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/solicitudes/${requestId}/cv`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + user.token
      },
    });
    

    if (response.ok) {
      const blob = await response.blob();
      dispatch({ type: 'GET_CV_REQUEST_SUCCESS' });

      // Establecer un nombre para el archivo
      const contentDisposition = response.headers.get('Content-Disposition');
      let fileName = 'archivo_cv.pdf'; // Nombre predeterminado

      if (contentDisposition && contentDisposition.includes('filename=')) {
        const match = contentDisposition.match(/filename="(.+?)"/);
        if (match && match[1]) {
          fileName = match[1]; // Nombre del archivo definido en los headers
        }
      }

      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = fileName; // Usar el nombre obtenido o el predeterminado
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);

    } else {
      if(response.status == 404){
        notifyError('No se ha encontrado el archivo correspondiente')
      }
      const errorData = await response.statusText;
      dispatch({ type: 'GET_CV_REQUEST_FAIL', payload: errorData });
    }

  }
  catch (error){
    dispatch({ type: 'GET_CV_REQUEST_ERROR', payload: error.message });
  }
};

export const createRequest = (requestData, file,fileCV,user, navigate, isJury) => async (dispatch) => {
  try {
    dispatch({ type: 'CREATE_REQUEST_REQUEST' });

    const formData = new FormData();

    Object.keys(requestData).forEach((key) => {
      formData.append(key, requestData[key]);
    });

    formData.append('file', file);
    formData.append('CV',fileCV)

    formData.append('model', JSON.stringify(requestData));

    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/solicitudes/save`, {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + user.token
      },
      body: formData
    });

    /*const response = await simulateApiPost(requestData);*/
   
    if (response.ok) {
      dispatch({ type: 'CREATE_REQUEST_SUCCESS', payload: requestData });
      navigate('/backoffice/request-sent');
    } else {
      const errorData = await response.json();
      notifyError(`Error: ${errorData.Message}`);
      dispatch({ type: 'CREATE_REQUEST_FAIL', payload: errorData.Message });
    }
  } catch (error) {
    
    notifyError(error.message)
    dispatch({ type: 'CREATE_REQUEST_ERROR', payload: error.message });
  }
};

export const getAllRequests = (user) => {
  return async (dispatch) => {
    try {
      dispatch({ type: 'GET_ALL_REQUESTS' });

      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/solicitudes?fechaDesde&fechaHasta&tipoMicro&estado`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + user.token
        },
      });

      if (!response.ok) {
        let errorData = response.statusText;
        try {
          const errorJson = await response.json();
          errorData = errorJson?.Message || errorJson?.message || errorData;
        } catch (parseError) {
          // keep statusText if body is not JSON
        }

        dispatch({
          type: 'GET_ALL_REQUESTS_ERROR',
          payload: errorData,
        });
        return;
      }

      const requestData = await response.json();
      dispatch({
        type: 'GET_ALL_REQUESTS_SUCCESS',
        payload: requestData,
      });
    } catch (error) {
      dispatch({
        type: 'GET_ALL_REQUESTS_ERROR',
        payload: error.message,
      });
    }
  };
};


// Update an existing request
export const updateRequest = (requestId, updatedData) => ({
  type: 'UPDATE_REQUEST',
  payload: { requestId, updatedData },
});

// Delete a request
export const deleteRequest = (requestId) => ({
  type: 'DELETE_REQUEST',
  payload: requestId,
});

export const approveRequest = (solicitudId, observaciones, user, navigate) => async (dispatch) => {
  try {
    dispatch({ type: 'APPROVE_REQUEST' });

    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/solicitudes/${solicitudId}/aprobar`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + user.token
      },
      body: JSON.stringify(observaciones)
    });

    if (response.ok) {
      notifySuccess("Solicitud aprobada correctamente.");
      dispatch({ type: 'APPROVE_REQUEST_SUCCESS' });
      setTimeout(() => navigate('/backoffice/request-detail-sent'), 1500);
    } else {
      const errorData = await response.json();
      notifyError(`Error: ${errorData.Message || 'Error al aprobar la solicitud'}`);
      dispatch({ type: 'APPROVE_REQUEST_FAIL', payload: errorData.Message });
    }
  } catch (error) {
    notifyError(error.message);
    dispatch({ type: 'APPROVE_REQUEST_ERROR', payload: error.message });
  }
};

export const rejectRequest = (solicitudId, observaciones, user, navigate) => async (dispatch) => {
  try {
    dispatch({ type: 'REJECT_REQUEST' });

    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/solicitudes/${solicitudId}/rechazar`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + user.token
      },
      body: JSON.stringify(observaciones)
    });

    if (response.ok) {
      notifySuccess("Solicitud rechazada correctamente.");
      dispatch({ type: 'REJECT_REQUEST_SUCCESS' });
      setTimeout(() => navigate('/backoffice/request-detail-fail'), 1500);
    } else {
      const errorData = await response.json();
      notifyError(`Error: ${errorData.Message || 'Error al rechazar la solicitud'}`);
      dispatch({ type: 'REJECT_REQUEST_FAIL', payload: errorData.Message });
    }
  } catch (error) {
    notifyError(error.message);
    dispatch({ type: 'REJECT_REQUEST_ERROR', payload: error.message });
  }
};

export const getMicrocredencialesCatalogo = (user) => {
    return async (dispatch) => {
        try {
            dispatch({ type: 'GET_MICROCREDENCIALES_CATALOGO' });

            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}microcredenciales/catalogo`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + user.token
                },
            });
            const requestData = await response.json();

            // Filtrar solo las microcredenciales (las que tienen guiones)
            const microcredenciales = requestData.filter(item => item.c_codigo_id.includes('-'));

            dispatch({
                type: 'GET_MICROCREDENCIALES_CATALOGO_SUCCESS',
                payload: microcredenciales,
            });
        } catch (error) {
            dispatch({
                type: 'GET_MICROCREDENCIALES_CATALOGO_ERROR',
                payload: error.message,
            });
        }
    };
};


